export default __webpack_public_path__ + "static/yawn-9ee254781ca3e303f466113e6ae6771b.mp3";